module.exports = __webpack_public_path__ + "static/media/default-book-hospital.64d03e6c.svg";